import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import CalculateIcon from "@mui/icons-material/Calculate";
import type { RegimeItemProps } from "./RegimeItem/types/RegimeItemProps";

export const regimesData: RegimeItemProps[] = [
  {
    name: "Simples Nacional",
    description: "Ideal para micro e pequenas empresas, com recolhimento de impostos unificado e simplificado.",
    icon: AttachMoneyIcon,
  },
  {
    name: "Lucro Presumido",
    description: "Base de cálculo simplificada do IRPJ e CSLL, muito utilizado por empresas de serviços e comércio.",
    icon: AccountBalanceWalletIcon,
  },
  {
    name: "Lucro Real",
    description:
      "Regime obrigatório para grandes empresas ou altamente recomendado para aquelas com margens de lucro baixas.",
    icon: CalculateIcon,
  },
];
